import ApiClient from './ApiClient'

const API_NAME = 'WeConnect'
const client = new ApiClient(API_NAME)

export default {
  index(businessId) {
    return client.get(`/business/${businessId}/document`)
  }
}
